import { render, staticRenderFns } from "./EditPromoMobile.vue?vue&type=template&id=078f94da&"
import script from "./EditPromoMobile.vue?vue&type=script&lang=js&"
export * from "./EditPromoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports